/** 介面型態 **/
export const UI_TABLE = "資料表"
export const UI_BUTTON = "按鈕"
export const UI_INPUT = "輸入欄"
export const UI_LIST = "選單"

/** 基礎按鈕 **/
export const BUTTON_LOGIN = '登入'
export const BUTTON_LOGOUT = '登出'
export const BUTTON_SEARCH = '查詢'
export const BUTTON_IMPORT_REFRESH = '重新整理'
export const BUTTON_SAVE = '儲存'
export const BUTTON_OK = '確定'
export const BUTTON_CANCEL = '取消'
export const BUTTON_DOWNLOAD = '下載'
export const BUTTON_UPLOAD = '上傳'
export const BUTTON_EXPORT_EXCEL = '匯出'
export const BUTTON_IMPORT_EXCEL = '匯入'

/**  基礎欄位 **/
export const FIELD_OPERATE_ITEM = "操作項目"

export const FIELD_ACCOUNT = "帳號"
export const FIELD_PASSWORD = "密碼"

export const FIELD_TW_ID = "身分證字號"
export const FIELD_TW_NAME = "姓名"

export const FIELD_POSITION_ID = "職號"
export const FIELD_STUDENT_ID = "學號"
export const FIELD_ACADEMIC_YEAR = "學年度"
export const FIELD_ACADEMIC_SEMESTER = "學期"
export const FIELD_SUBJECT_CODE = "科目代碼"
export const FIELD_COURSE = "課程"
export const FIELD_COURSE_NAME = "課程名稱"